import { SET_CREDENTIALS } from 'src/redux/actions/credentials';


const initialState = {
  mpUserId: 0,
  identityId: ''
};

const credentialsReducer = (state = initialState, { type, payload }) => ({
  [SET_CREDENTIALS]: () => ({ ...state, ...payload })
}[type] || (() => state))();

export default credentialsReducer;
